import React, { useState, useMemo, useRef } from "react";
import KPIStrip from "../components/KPIStrip";
import WaterUsageFilters, {
  DEFAULT_FILTERS,
} from "../components/WaterUsageFilters";
import WeeklyTrendChart from "../components/WeeklyTrendChart";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import {
  getAccountMeterCategoryList,
  getWaterUsageKPI,
  getMetersByFlow,
  getDailyHourlyTrend,
  getWaterUsageBreakdown,
} from "../services";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Spin } from "antd";
import { useDistrict } from "../utils/DistrictContext";
import {
  ArrowDown,
  ArrowUp,
  ArrowUpDown,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
// =========================
// STATIC DATA
// =========================

// const CATEGORIES = [
//   { code: "IC", name: "Interconnect" },
//   { code: "NPS", name: "Non-Potable Supply" },
//   { code: "PD", name: "Potable Domestic" },
//   { code: "PF", name: "Potable Fire" },
//   { code: "PI", name: "Potable Irrigation" },
// ];

// const accounts = [
//   { id: 1, name: "Chick-Fil-A Summerwood" },
//   { id: 2, name: "City of Houston" },
//   { id: 3, name: "GHX Industrial" },
//   { id: 4, name: "Generation Park" },
//   { id: 5, name: "Kroger" },
//   { id: 6, name: "Lockwood" },
//   { id: 7, name: "Lone Star College" },
//   { id: 8, name: "Memorial Hermann Hospital" },
//   { id: 9, name: "San Jacinto Community College" },
//   { id: 10, name: "Service Wire Company" },
//   { id: 11, name: "Westlake Marketplace" },
//   { id: 12, name: "PHMSCM Holdings" },
// ];

// const meters = [
//   { id: "129122", name: "129122 — Westlake Marketplace" },
//   { id: "114476", name: "114476 — Generation Park" },
//   { id: "114477", name: "114477 — Lone Star College" },
//   { id: "101893", name: "101893 — Memorial Hermann Hospital" },
//   { id: "126171", name: "126171 — Kroger" },
//   { id: "96881H", name: "96881H — Lockwood" },
//   { id: "96882L", name: "96882L — Lockwood" },
//   { id: "95434", name: "95434 — San Jacinto Community College" },
//   { id: "129123", name: "129123 — Generation Park" },
//   { id: "17160335", name: "17160335 — City of Houston" },
//   { id: "47149L", name: "47149L — GHX Industrial" },
//   { id: "86287L", name: "86287L — Service Wire Company" },
// ];

// const kpis = {
//   supply: {
//     value: 120000,
//     deltaPct: 5.2,
//   },
//   demand: {
//     value: 92000,
//     deltaPct: 2.1,
//   },
//   loss: {
//     value: 28000,
//     deltaPct: -1.5,
//   },
//   avgDaily: {
//     value: 4500,
//     deltaPct: 1.2,
//   },
//   peak: {
//     value: 9800,
//     dateLabel: "May 10",
//   },
// };

// const filteredKpis = {
//   supply: {
//     value: 9354300,
//     deltaPct: 4.5,
//   },
//   demand: {
//     value: 6165567,
//     deltaPct: 4.1,
//   },
//   loss: {
//     value: 3188733,
//     deltaPct: 5.2,
//   },
//   avgDaily: {
//     value: 311810,
//     deltaPct: 4.2,
//   },
//   peak: {
//     value: 520400,
//     dateLabel: "Apr 30 (Thu)",
//   },
// };

const aggregate = [
  { x: "May 01", y: 12000 },
  { x: "May 02", y: 15000 },
  { x: "May 03", y: 11000 },
  { x: "May 04", y: 18000 },
  { x: "May 05", y: 17000 },
  { x: "May 06", y: 14000 },
  { x: "May 07", y: 19000 },
  { x: "May 08", y: 16000 },
  { x: "May 09", y: 13000 },
  { x: "May 10", y: 21000 },
  { x: "May 11", y: 17500 },
  { x: "May 12", y: 14500 },
  { x: "May 13", y: 22000 },
  { x: "May 14", y: 19500 },
  { x: "May 15", y: 25000 },

  // NEW 10 VALUES

  { x: "May 16", y: 23000 },
  { x: "May 17", y: 18500 },
  { x: "May 18", y: 26000 },
  { x: "May 19", y: 24000 },
  { x: "May 20", y: 27500 },
  { x: "May 21", y: 25500 },
  { x: "May 22", y: 29000 },
  { x: "May 23", y: 31000 },
  { x: "May 24", y: 28000 },
  { x: "May 25", y: 32500 },
];

const dailyAvg = [
  { x: "Weekday", y: 5600 },
  { x: "Weekend", y: 6800 },
  { x: "Monday", y: 4200 },
  { x: "Tuesday", y: 5100 },
  { x: "Wednesday", y: 4800 },
  { x: "Thursday", y: 5300 },
  { x: "Friday", y: 6200 },
  { x: "Saturday", y: 7100 },
  { x: "Sunday", y: 3900 },
];

const hourlyAvg = [
  { x: "12am", y: 10500 },
  { x: "1am", y: 9800 },
  { x: "2am", y: 9500 },
  { x: "3am", y: 9700 },
  { x: "4am", y: 10200 },
  { x: "5am", y: 12000 },
  { x: "6am", y: 14500 },
  { x: "7am", y: 16200 },
  { x: "8am", y: 15800 },
  { x: "9am", y: 14200 },
  { x: "10am", y: 13500 },
  { x: "11am", y: 13000 },
  { x: "12pm", y: 12800 },
  { x: "1pm", y: 12500 },
  { x: "2pm", y: 12300 },
  { x: "3pm", y: 13800 },
  { x: "4pm", y: 17500 },
  { x: "5pm", y: 21800 },
  { x: "6pm", y: 23200 },
  { x: "7pm", y: 21500 },
  { x: "8pm", y: 18200 },
  { x: "9pm", y: 15500 },
  { x: "10pm", y: 13200 },
  { x: "11pm", y: 11500 },
];

// const categoryData = [
//   { name: "Potable Domestic", value: 82.1 },
//   { name: "Potable Irrigation", value: 16.2 },
//   { name: "Non-Potable Supply", value: 1.0 },
//   { name: "Potable Fire", value: 0.4 },
//   { name: "Interconnect", value: 0.3 },
// ];
// const categoryBreakdown = useMemo(() => {
//   // Aggregate meterRankings by category name
//   const counts = meterRankings.reduce((acc, curr) => {
//     acc[curr.code_name] = (acc[curr.code_name] || 0) + curr.flow;
//     return acc;
//   }, {});

//   return Object.entries(counts).map(([name, value]) => ({ name, value }));
// }, [meterRankings]);
// const topAccounts = [
//   { name: "Westlake", value: 14832 },
//   { name: "Gen Park", value: 12401 },
//   { name: "Lone Star", value: 9876 },
//   { name: "Mem Hermann", value: 8224 },
//   { name: "Kroger", value: 7109 },
// ];
// const liveTopAccounts = useMemo(() => {
//   return meterRankings
//     .slice(0, 5) // Take top 5
//     .map((m) => ({ name: m.account_name, value: m.flow }));
// }, [meterRankings]);
const weekly = [
  {
    name: "Apr 6–12",
    data: [2700, 2860, 2780, 2710, 2950, 2950, 2280],
  },
  {
    name: "Apr 13–19",
    data: [2750, 2890, 2810, 2740, 3000, 3010, 2310],
  },
  {
    name: "Apr 20–26",
    data: [2810, 2940, 2870, 3060, 3300, 3220, 2350],
  },
  {
    name: "Apr 27–May 3",
    data: [2880, 3010, 2920, 2840, 3120, 3812, 2410],
  },
];
const rankedMeters = [
  {
    meter_id: "129122",
    category: "Potable Domestic",
    account_name: "Westlake Marketplace",
    last_comm_time: "2026-05-04 14:32",
    flow: 14832,
  },
  {
    meter_id: "114476",
    category: "Potable Domestic",
    account_name: "Generation Park",
    last_comm_time: "2026-05-04 14:28",
    flow: 12401,
  },
  {
    meter_id: "114477",
    category: "Potable Domestic",
    account_name: "Lone Star College",
    last_comm_time: "2026-05-04 14:30",
    flow: 9876,
  },
  {
    meter_id: "101893",
    category: "Potable Irrigation",
    account_name: "Memorial Hermann Hospital",
    last_comm_time: "2026-05-04 14:31",
    flow: 8224,
  },
  {
    meter_id: "126171",
    category: "Potable Domestic",
    account_name: "Kroger",
    last_comm_time: "2026-05-04 14:25",
    flow: 7109,
  },
  {
    meter_id: "96881H",
    category: "Potable Fire",
    account_name: "Lockwood",
    last_comm_time: "2026-05-04 14:33",
    flow: 6543,
  },
  {
    meter_id: "96882L",
    category: "Potable Domestic",
    account_name: "Lockwood",
    last_comm_time: "2026-05-04 14:33",
    flow: 5981,
  },
  {
    meter_id: "95434",
    category: "Non-Potable Supply",
    account_name: "San Jacinto Community College",
    last_comm_time: "2026-05-04 14:18",
    flow: 4872,
  },
  {
    meter_id: "129123",
    category: "Non-Potable Supply",
    account_name: "Generation Park",
    last_comm_time: "2026-05-03 22:14",
    flow: 3920,
  },
  {
    meter_id: "17160335",
    category: "Interconnect",
    account_name: "City of Houston",
    last_comm_time: "2026-05-04 14:00",
    flow: 2110,
  },
  {
    meter_id: "47149L",
    category: "Potable Domestic",
    account_name: "GHX Industrial",
    last_comm_time: "2026-05-04 13:50",
    flow: 1845,
  },
  {
    meter_id: "86287L",
    category: "Potable Irrigation",
    account_name: "Service Wire Company",
    last_comm_time: "2026-05-04 13:30",
    flow: 1402,
  },
];
// =========================
// CHART BASE CONFIG
// =========================

const zoomToolbar = {
  show: true,
  tools: {
    download: false,
    selection: true,
    zoom: true,
    zoomin: true,
    zoomout: true,
    pan: true,
    reset: true,
  },
  autoSelected: "zoom",
};

const zoomConfig = {
  enabled: true,
  type: "x",
  autoScaleYaxis: true,
};

const themedChartBase = {
  chart: {
    foreColor: "#8ba1c7",
    toolbar: zoomToolbar,
    zoom: zoomConfig,
  },

  grid: {
    borderColor: "#233d5e",
    strokeDashArray: 3,
  },

  tooltip: {
    theme: "dark",
  },

  legend: {
    labels: {
      colors: "#e6f0ff",
    },
  },
};

// =========================
// COMPONENT
// =========================

const WaterCombined = () => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const navigate = useNavigate();
  const { selectedDistrict } = useDistrict();

  const districtId =
    typeof selectedDistrict === "object"
      ? selectedDistrict?.selectedDistrict ||
        selectedDistrict?.district ||
        selectedDistrict?.id ||
        ""
      : selectedDistrict || "";

  const [isLoading, setIsLoading] = useState(true);

  const [aggType, setAggType] = useState("bar");
  const [dailyType, setDailyType] = useState("bar");

  const [hourlyType, setHourlyType] = useState("line");
  const [acctType, setAcctType] = useState("bar");
  const [activeCategory, setActiveCategory] = useState(null);
  const { colors, theme } = useTheme();
  const cardStyle = {
  backgroundColor: colors.cardBg,
  borderColor: colors.border,
};

const [optionFilters, setOptionFilters] = useState({
  account: [],
  meter: [],
  category: [],
});

const innerCardStyle = {
  backgroundColor: colors.background,
  borderColor: colors.border,
};

const mutedTextStyle = {
  color: colors.textSecondary,
};

const mainTextStyle = {
  color: colors.text,
};

const themedChartBase = useMemo(() => {
  const isLightTheme = theme === "white" || theme === "light";

  return {
    chart: {
      foreColor: colors.textSecondary,
      toolbar: zoomToolbar,
      zoom: zoomConfig,
    },

    grid: {
      borderColor: colors.border,
      strokeDashArray: 3,
    },

    tooltip: {
      theme: isLightTheme ? "light" : "dark",
    },

    legend: {
      labels: {
        colors: colors.text,
      },
    },
  };
}, [colors, theme]);


  const [dhTab, setDhTab] = useState("daily");

  const [hourlyDay, setHourlyDay] = useState("Weekdays");

  const [sort, setSort] = useState({
    key: "flow",
    direction: "desc",
  });

  //   pagination

  const [meterPage, setMeterPage] = useState(1);
  const [meterPageSize, setMeterPageSize] = useState(10);

  const [options, setOptions] = useState({
    accounts: [],
    meters: [],
    categories: [],
  });
  const [meterRankings, setMeterRankings] = useState([]);
  const [loadingRankings, setLoadingRankings] = useState(false);
  // const categoryBreakdown = useMemo(() => {
  //   const counts = meterRankings.reduce((acc, curr) => {
  //     const categoryName = curr.code_name || "Unknown";
  //     const flowValue = Number(curr.flow || 0);

  //     acc[categoryName] = (acc[categoryName] || 0) + flowValue;

  //     return acc;
  //   }, {});

  //   return Object.entries(counts).map(([name, value]) => ({
  //     name,
  //     value,
  //   }));
  // }, [meterRankings]);

  // const liveTopAccounts = useMemo(() => {
  //   return [...meterRankings]
  //     .sort((a, b) => Number(b.flow || 0) - Number(a.flow || 0))
  //     .slice(0, 5)
  //     .map((m) => ({
  //       name: m.account_name || "Unknown",
  //       value: Number(m.flow || 0),
  //     }));
  // }, [meterRankings]);

const allAccountsRef = useRef([]);

useEffect(() => {
  setOptionFilters({
    account: [],
    meter: [],
    category: [],
  });
}, [districtId]);

const [breakdownData, setBreakdownData] = useState({
  breakdownTitle: "By Category",
  topFlowTitle: "Top Accounts — Total Flow In Range",
  categoryBreakdown: [],
  liveTopAccounts: [],
  totalFlowGallons: 0,
});

const [loadingBreakdown, setLoadingBreakdown] = useState(false);

const categoryBreakdown = breakdownData.categoryBreakdown;
const liveTopAccounts = breakdownData.liveTopAccounts;
const totalFlowGallons = breakdownData.totalFlowGallons;
const breakdownTitle = breakdownData.breakdownTitle;
const topFlowTitle = breakdownData.topFlowTitle;


  const [kpiData, setKpiData] = useState(null);
  const [loadingKpis, setLoadingKpis] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [chartData, setChartData] = useState({
    aggregate: [],
    dailyAvg: [],
    hourlyAvg: [],
    weeklyTrend: [],
  });
  const [loadingCharts, setLoadingCharts] = useState(false);
  const selectedAccountCount = filters.account?.length || 0;
  const selectedMeterCount = filters.meter?.length || 0;
  const selectedCategoryCount = filters.category?.length || 0;

  const isFilteredView =
    selectedAccountCount > 0 ||
    selectedMeterCount > 0 ||
    selectedCategoryCount > 0;

  // const activeKpis = isFilteredView ? filteredKpis : kpis;

  const filteredText = [
    selectedAccountCount > 0 ? `${selectedAccountCount} account` : null,
    selectedMeterCount > 0 ? `${selectedMeterCount} meter` : null,
    selectedCategoryCount > 0 ? `${selectedCategoryCount} category` : null,
  ]
    .filter(Boolean)
    .join(" / ");

  const clearFilters = () => {
    setFilters({
      ...filters,
      account: [],
      meter: [],
      category: [],
    });
  };

  const kpiRequestKeyRef = useRef("");
  const rankingRequestKeyRef = useRef("");
  const optionsRequestKeyRef = useRef("");
const trendRequestKeyRef = useRef("");
const breakdownRequestKeyRef = useRef("");
const previousDistrictRef = useRef(null);

  const getFilterKey = (filters, districtId) => {
    return JSON.stringify({
      districtId,
      mode: filters.mode,
      chip: filters.chip,
      start: filters.start,
      end: filters.end,
      interval: filters.interval,
      account: filters.account || [],
      meter: filters.meter || [],
      category: filters.category || [],
    });
  };
  // =========================
  // KPI MODE
  // =========================

  // const kpiMode =
  //   filters.account?.length ||
  //   filters.meter?.length
  //     ? "filtered"
  //     : "district";

  // =========================
  // SORTING
  // =========================

  // const sortedMeters = useMemo(() => {
  //   const dir = sort.dir === "asc" ? 1 : -1;

  //   return [...rankedMeters].sort((a, b) => {
  //     const av = a[sort.key];
  //     const bv = b[sort.key];

  //     if (typeof av === "number") {
  //       return (av - bv) * dir;
  //     }

  //     return String(av ?? "").localeCompare(String(bv ?? "")) * dir;
  //   });
  // }, [sort]);
  const sortedMeters = useMemo(() => {
    let data = [...meterRankings];

    if (sort.key) {
      data.sort((a, b) => {
        const aValue = a[sort.key];
        const bValue = b[sort.key];

        const aNum = Number(aValue);
        const bNum = Number(bValue);

        const bothNumbers =
          aValue !== null &&
          aValue !== undefined &&
          bValue !== null &&
          bValue !== undefined &&
          !Number.isNaN(aNum) &&
          !Number.isNaN(bNum);

        if (bothNumbers) {
          return sort.direction === "asc" ? aNum - bNum : bNum - aNum;
        }

        return sort.direction === "asc"
          ? String(aValue || "").localeCompare(String(bValue || ""))
          : String(bValue || "").localeCompare(String(aValue || ""));
      });
    }

    return data;
  }, [meterRankings, sort]);

  const meterTotalPages = Math.ceil(sortedMeters.length / meterPageSize);

  const meterStartIndex = (meterPage - 1) * meterPageSize;

  const paginatedMeters = sortedMeters.slice(
    meterStartIndex,
    meterStartIndex + meterPageSize,
  );

  useEffect(() => {
    setMeterPage(1);
  }, [sort, filters]);

  const onSortClick = (key) => {
    if (key === "rank") return;

    setSort((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));

    setMeterPage(1);
  };

  const SortIcon = ({ columnKey }) => {
    if (sort.key !== columnKey) {
      return (
        <ArrowUpDown className="w-4 h-4" style={{ color: colors.primary }} />
      );
    }

    return sort.direction === "asc" ? (
      <ArrowUp className="w-4 h-4" style={{ color: colors.primary }} />
    ) : (
      <ArrowDown className="w-4 h-4" style={{ color: colors.primary }} />
    );
  };

  const sortClass = (key) =>
    "sortable" + (sort.key === key ? ` sort-${sort.dir}` : "");

  const sortArrow = (key) =>
    sort.key === key ? (sort.dir === "asc" ? "▲" : "▼") : "▲▼";

  // =========================
  // AGGREGATE CONFIG
  // =========================

const aggregateConfig = useMemo(() => {
  const pointCount = chartData.aggregate.length;
  const isLargeData = pointCount > 80;

  return {
    ...themedChartBase,

    chart: {
      ...themedChartBase.chart,
      type: aggType,
      height: 320,
      toolbar: {
        ...themedChartBase.chart.toolbar,
        show: true,
      },
      zoom: {
        enabled: true,
        type: "x",
        autoScaleYaxis: true,
      },
    },

    xaxis: {
      type: "datetime",
      tickAmount: isLargeData ? 8 : 10,

      labels: {
        rotate: 0,
        datetimeUTC: false,
        hideOverlappingLabels: true,
        style: {
          colors: "#8ba1c7",
          fontSize: "11px",
        },
        formatter: (value, timestamp) => {
          const date = new Date(timestamp || value);

          if (filters.interval === "Hour") {
            return date.toLocaleString("en-US", {
              month: "short",
              day: "2-digit",
              hour: "numeric",
            });
          }

          return date.toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
          });
        },
      },

      tooltip: {
        enabled: false,
      },
    },

    yaxis: {
      labels: {
        formatter: (value) => Number(value || 0).toLocaleString(),
        style: {
          colors: "#8ba1c7",
          fontSize: "11px",
        },
      },
    },

    colors: ["#1998f0"],

    dataLabels: {
      enabled: false,
    },

    stroke:
      aggType === "line"
        ? {
            width: 2.5,
            curve: "smooth",
          }
        : {
            width: 0,
          },

    markers: {
      size: 0,
    },

    plotOptions:
      aggType === "bar"
        ? {
            bar: {
              borderRadius: 2,
              columnWidth: isLargeData ? "85%" : "65%",
            },
          }
        : {},

    fill: {
      opacity: 1,
    },

    tooltip: {
      theme: "dark",
      x: {
        formatter: (value) => {
          const date = new Date(value);

          return date.toLocaleString("en-US", {
            weekday: "short",
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
          });
        },
      },
      y: {
        formatter: (value) => `${Number(value || 0).toLocaleString()} gal`,
      },
    },

    grid: {
      borderColor: "#233d5e",
      strokeDashArray: 3,
      padding: {
        left: 10,
        right: 20,
        bottom: 10,
      },
    },
  };
}, [aggType, chartData.aggregate.length, filters.interval]);

  // =========================
  // DAILY CONFIG
  // =========================

  const dailyConfig = useMemo(() => {
    return {
      ...themedChartBase,

      chart: {
        ...themedChartBase.chart,
        type: dailyType,
        height: 420,
      },

      series: [
        {
          name: "Daily Avg",
          data: dailyAvg.map((p) => p.y),
        },
      ],

      xaxis: {
        categories: dailyAvg.map((p) => p.x),

        labels: {
          style: {
            colors: colors.textSecondary,
            fontSize: "12px",
          },
        },
      },

      yaxis: {
        labels: {
          formatter: (v) => Number(v).toLocaleString(),

          style: {
            colors: colors.textSecondary,
          },
        },
      },

      colors: ["#1998f0"],

      dataLabels: {
        enabled: false,
      },

      stroke:
        dailyType === "line"
          ? {
              width: 4,
              curve: "smooth",
            }
          : {
              width: 0,
            },

      markers:
        dailyType === "line"
          ? {
              size: 5,
              strokeWidth: 2,
            }
          : {
              size: 0,
            },

      plotOptions:
        dailyType === "bar"
          ? {
              bar: {
                borderRadius: 4,
                columnWidth: "70%",
              },
            }
          : {},

      tooltip: {
        theme: "dark",
      },

      legend: {
        show: false,
      },
    };
  }, [dailyType]);

  // =========================
  // HOURLY CONFIG
  // =========================

  const hourlyConfig = useMemo(() => {
    return {
      ...themedChartBase,

      chart: {
        ...themedChartBase.chart,
        type: hourlyType,
        height: 420,
      },

      series: [
        {
          name: "Total Demand Hourly Avg",
          data: hourlyAvg.map((p) => p.y),
        },
      ],

      xaxis: {
        categories: hourlyAvg.map((p) => p.x),

        labels: {
          style: {
            colors: colors.textSecondary,
            fontSize: "11px",
          },
        },
      },

      yaxis: {
        labels: {
          formatter: (v) => Number(v).toLocaleString(),

          style: {
            colors: colors.textSecondary,
          },
        },
      },

      legend: {
        show: true,

        labels: {
          colors: colors.textSecondary,
        },
      },

      dataLabels: {
        enabled: false,
      },

      colors: ["#1998f0"],

      stroke:
        hourlyType === "line"
          ? {
              width: 3,
              curve: "monotoneCubic",
            }
          : {
              width: 0,
            },

      markers:
        hourlyType === "line"
          ? {
              size: 5,
            }
          : {
              size: 0,
            },

      plotOptions:
        hourlyType === "bar"
          ? {
              bar: {
                borderRadius: 4,
                columnWidth: "70%",
              },
            }
          : {},
    };
  }, [hourlyType]);

  // =========================
  // CATEGORY CONFIG
  // =========================

const categoryConfig = {
  ...themedChartBase,

  chart: {
    ...themedChartBase.chart,
    type: "donut",
    height: 320,
    toolbar: {
      show: false,
    },

    events: {
      dataPointMouseEnter: (event, chartContext, config) => {
        const index = config.dataPointIndex;

        if (index >= 0) {
          setActiveCategory({
            name: categoryBreakdown[index]?.name,
            value: categoryBreakdown[index]?.value,
            sharePct: categoryBreakdown[index]?.sharePct,
          });
        }
      },

      dataPointMouseLeave: () => {
        setActiveCategory(null);
      },
    },
  },

  series: categoryBreakdown.map((c) => c.value),
  labels: categoryBreakdown.map((c) => c.name),

  colors: ["#2ea8ff", "#30c5d8", "#ff7b1a", "#c05be3", "#7ed37e"],

  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "center",

    labels: {
      colors: "#ffffff",
    },

    markers: {
      width: 12,
      height: 12,
      radius: 12,
    },

    itemMargin: {
      horizontal: 8,
      vertical: 6,
    },
  },

  dataLabels: {
    enabled: true,
    formatter: (val) => `${Number(val || 0).toFixed(1)}%`,

    style: {
      fontSize: "12px",
      fontWeight: 700,
      colors: ["#000000"],
    },

    dropShadow: {
      enabled: false,
    },
  },

  stroke: {
    width: 2,
    colors: ["#132742"],
  },

  plotOptions: {
    pie: {
      expandOnClick: false,

      donut: {
        size: "62%",

        labels: {
          show: true,

          name: {
            show: true,
            color: "#8ba1c7",
            fontSize: "16px",
            fontWeight: 400,
            offsetY: -8,
            formatter: () =>
              activeCategory ? activeCategory.name : "Total gal",
          },

          value: {
            show: true,
            color: "#8ba1c7",
            fontSize: "24px",
            fontWeight: 500,
            offsetY: 8,
            formatter: () =>
              activeCategory
                ? `${Number(activeCategory.sharePct || 0).toFixed(1)}%`
                : Number(totalFlowGallons || 0).toLocaleString(),
          },

          total: {
            show: true,
            showAlways: true,
            label: activeCategory ? activeCategory.name : "Total gal",
            color: "#8ba1c7",
            fontSize: "16px",
            fontWeight: 400,
            formatter: () =>
              activeCategory
                ? `${Number(activeCategory.sharePct || 0).toFixed(1)}%`
                : Number(totalFlowGallons || 0).toLocaleString(),
          },
        },
      },
    },
  },

tooltip: {
  enabled: true,
  theme: "dark",
  custom: ({ series, seriesIndex, dataPointIndex, w }) => {
    const item = categoryBreakdown[seriesIndex];

    if (!item) return "";

    const flowValue = Number(item.value || 0).toLocaleString();
    const sharePct = Number(item.sharePct || 0).toFixed(1);

    return `
      <div style="
        background: #0d223a;
        border: 1px solid #2ea8ff;
        border-radius: 10px;
        padding: 10px 12px;
        min-width: 220px;
        max-width: 280px;
        color: #ffffff;
        box-shadow: 0 8px 24px rgba(0,0,0,0.35);
        font-family: inherit;
      ">
        <div style="
          font-size: 13px;
          font-weight: 700;
          color: #2ea8ff;
          margin-bottom: 8px;
          white-space: normal;
          word-break: break-word;
        ">
          ${item.name || "Unknown"}
        </div>

        <div style="display: flex; justify-content: space-between; gap: 12px; margin-bottom: 6px;">
          <span style="color: #8ba1c7; font-size: 12px;">Flow</span>
          <span style="color: #ffffff; font-size: 12px; font-weight: 600;">
            ${flowValue} gal
          </span>
        </div>

        <div style="display: flex; justify-content: space-between; gap: 12px; margin-bottom: 6px;">
          <span style="color: #8ba1c7; font-size: 12px;">Share</span>
          <span style="color: #ffffff; font-size: 12px; font-weight: 600;">
            ${sharePct}%
          </span>
        </div>

        ${
          item.meterName
            ? `
              <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #23446f;">
                <div style="color: #8ba1c7; font-size: 11px; margin-bottom: 2px;">Meter</div>
                <div style="color: #ffffff; font-size: 12px; font-weight: 600; word-break: break-word;">
                  ${item.meterName}
                </div>
              </div>
            `
            : ""
        }

        ${
          item.accountName
            ? `
              <div style="margin-top: 8px;">
                <div style="color: #8ba1c7; font-size: 11px; margin-bottom: 2px;">Account</div>
                <div style="color: #ffffff; font-size: 12px; font-weight: 600; word-break: break-word;">
                  ${item.accountName}
                </div>
              </div>
            `
            : ""
        }

        ${
          item.categoryName
            ? `
              <div style="margin-top: 8px;">
                <div style="color: #8ba1c7; font-size: 11px; margin-bottom: 2px;">Category</div>
                <div style="color: #ffffff; font-size: 12px; font-weight: 600; word-break: break-word;">
                  ${item.categoryName}
                </div>
              </div>
            `
            : ""
        }
      </div>
    `;
  },
},
};

  // =========================
  // ACCOUNT CONFIG
  // =========================

// const accountConfig = useMemo(() => {
//   return {
//     ...themedChartBase,

//     chart: {
//       ...themedChartBase.chart,
//       type: acctType,
//       height: 300,
//     },

//     xaxis: {
//       categories: liveTopAccounts.map((a) => a.name),

//       labels: {
//         style: {
//           colors: colors.textSecondary,
//         },
//       },
//     },

//     yaxis: {
//       labels: {
//         formatter: (value) => Number(value || 0).toLocaleString(),
//         style: {
//           colors: colors.textSecondary,
//         },
//       },
//     },

//     colors: ["#2ea8ff"],

//     dataLabels: {
//       enabled: true,
//       formatter: (value) => Number(value || 0).toLocaleString(),
//       offsetY: acctType === "line" ? -10 : 0,
//       background: {
//         enabled: false,
//       },
//       style: {
//         colors: ["#ffffff"],
//         fontSize: "12px",
//         fontWeight: 700,
//       },
//     },

//     plotOptions:
//       acctType === "bar"
//         ? {
//             bar: {
//               horizontal: true,
//               borderRadius: 4,
//               barHeight: "55%",
//             },
//           }
//         : {},

//     stroke:
//       acctType === "line"
//         ? {
//             width: 3,
//             curve: "smooth",
//           }
//         : {
//             width: 0,
//           },

//     markers:
//       acctType === "line"
//         ? {
//             size: 5,
//             strokeWidth: 2,
//             strokeColors: "#ffffff",
//             hover: {
//               size: 7,
//             },
//           }
//         : {
//             size: 0,
//           },

//     tooltip: {
//       theme: "dark",
//       y: {
//         formatter: (value) => `${Number(value || 0).toLocaleString()} gal`,
//       },
//     },
//   };
// }, [acctType, liveTopAccounts]);

const shortenLabel = (label, maxLength = 18) => {
  const text = String(label || "");

  if (text.length <= maxLength) return text;

  return `${text.slice(0, maxLength)}...`;
};

const accountConfig = useMemo(() => {
  const accountNames = liveTopAccounts.map((a) => a.name);
  const accountValues = liveTopAccounts.map((a) => Number(a.value || 0));

  return {
    ...themedChartBase,

    chart: {
      ...themedChartBase.chart,
      type: acctType,
      height: 300,
      toolbar: {
        ...themedChartBase.chart.toolbar,
        show: true,
      },
    },

    xaxis: {
      categories: accountNames,

      labels: {
        rotate: acctType === "line" ? -45 : 0,
        rotateAlways: acctType === "line",
        trim: true,
        hideOverlappingLabels: true,

        formatter: (value) => {
          if (acctType === "bar") {
            return Number(value || 0).toLocaleString();
          }

          return shortenLabel(value, 16);
        },

        style: {
          colors: colors.textSecondary,
          fontSize: "11px",
        },
      },

      tooltip: {
        enabled: false,
      },
    },

    yaxis: {
      labels: {
        formatter: (value) => {
          if (acctType === "bar") {
            return shortenLabel(value, 18);
          }

          return Number(value || 0).toLocaleString();
        },

        style: {
          colors: colors.textSecondary,
          fontSize: "11px",
        },
      },
    },

    colors: ["#2ea8ff"],

    dataLabels: {
      enabled: true,

      formatter: (value) => Number(value || 0).toLocaleString(),

      offsetY: acctType === "line" ? -10 : 0,

      background: {
        enabled: false,
      },

      style: {
        colors: ["#ffffff"],
        fontSize: "12px",
        fontWeight: 700,
      },
    },

    plotOptions:
      acctType === "bar"
        ? {
            bar: {
              horizontal: true,
              borderRadius: 4,
              barHeight: "55%",
              dataLabels: {
                position: "center",
              },
            },
          }
        : {},

    stroke:
      acctType === "line"
        ? {
            width: 3,
            curve: "smooth",
          }
        : {
            width: 0,
          },

    markers:
      acctType === "line"
        ? {
            size: 5,
            strokeWidth: 2,
            strokeColors: "#ffffff",
            hover: {
              size: 7,
            },
          }
        : {
            size: 0,
          },

    tooltip: {
      theme: theme === "white" || theme === "light" ? "light" : "dark",

      x: {
        formatter: (value, opts) => {
          return accountNames[opts.dataPointIndex] || value;
        },
      },

      y: {
        formatter: (value) => `${Number(value || 0).toLocaleString()} gal`,
      },
    },

    grid: {
      borderColor: "#233d5e",
      strokeDashArray: 3,
      padding: {
        left: acctType === "bar" ? 10 : 20,
        right: 20,
        bottom: acctType === "line" ? 35 : 10,
      },
    },
  };
}, [acctType, liveTopAccounts]);

  // WaterCombined.jsx
const parseFlowTime = (flowTime) => {
  if (!flowTime) return null;

  // API format: "Tuesday, Apr 14, 2026 12:00 AM"
  const cleaned = String(flowTime).replace(/^[A-Za-z]+,\s*/, "");
  const date = new Date(cleaned);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.getTime();
};
  

useEffect(() => {
  if (!districtId) return;

  // First render
  if (previousDistrictRef.current === null) {
    previousDistrictRef.current = districtId;
    return;
  }

  // Same district
  if (previousDistrictRef.current === districtId) {
    return;
  }

  previousDistrictRef.current = districtId;

  // Clear selected filters
  setFilters((prev) => ({
    ...prev,
    account: [],
    meter: [],
    category: [],
  }));

  // Clear old UI data
  setOptions({
    accounts: [],
    meters: [],
    categories: [],
  });

  setMeterRankings([]);

  setChartData({
    aggregate: [],
    dailyAvg: [],
    hourlyAvg: [],
    weeklyTrend: [],
  });

  setBreakdownData({
    breakdownTitle: "By Category",
    topFlowTitle: "Top Accounts — Total Flow In Range",
    categoryBreakdown: [],
    liveTopAccounts: [],
    totalFlowGallons: 0,
  });

  // Very important: clear request guards when district changes
  allAccountsRef.current = [];
  optionsRequestKeyRef.current = "";
  kpiRequestKeyRef.current = "";
  rankingRequestKeyRef.current = "";
  trendRequestKeyRef.current = "";
  breakdownRequestKeyRef.current = "";
}, [districtId]);

  // Inside WaterCombined.jsx for Dropdown Options
useEffect(() => {
  const fetchOptions = async () => {
    if (!districtId) return;

    const requestKey = JSON.stringify({
      districtId,
      account: optionFilters.account || [],
      meter: optionFilters.meter || [],
      category: optionFilters.category || [],
    });

    if (optionsRequestKeyRef.current === requestKey) {
      return;
    }

    optionsRequestKeyRef.current = requestKey;

    try {
      setLoadingOptions(true);

      /*
        Important logic:

        Accounts dropdown should NOT be filtered by selected accounts.
        Meters dropdown should NOT be filtered by selected meters.
        Category dropdown should NOT be filtered by selected categories.
      */

      const accountPayload = {
        accounts: [],
        meter_ids: optionFilters.meter || [],
        codes: optionFilters.category || [],
      };

      const meterPayload = {
        accounts: optionFilters.account || [],
        meter_ids: [],
        codes: optionFilters.category || [],
      };

      const categoryPayload = {
        accounts: optionFilters.account || [],
        meter_ids: optionFilters.meter || [],
        codes: [],
      };

      const [accountResponse, meterResponse, categoryResponse] =
        await Promise.all([
          getAccountMeterCategoryList(accountPayload),
          getAccountMeterCategoryList(meterPayload),
          getAccountMeterCategoryList(categoryPayload),
        ]);

      const accountData = accountResponse?.data;
      const meterData = meterResponse?.data;
      const categoryData = categoryResponse?.data;

      setOptions({
        accounts: (accountData?.accounts || []).map((acc) => ({
          id: acc.account_name,
          name: acc.account_name,
        })),

        meters: (meterData?.meters || []).map((m) => ({
          id: m.meter_id,
          name: m.meter_id,
        })),

        categories: (categoryData?.codes || []).map((c) => ({
          code: c.code,
          name: c.code_name,
        })),
      });
    } catch (error) {
      console.error("Error fetching dropdown options:", error);

      setOptions({
        accounts: [],
        meters: [],
        categories: [],
      });
    } finally {
      setLoadingOptions(false);
    }
  };

  fetchOptions();
}, [
  districtId,
  optionFilters.account,
  optionFilters.meter,
  optionFilters.category,
]);



  // KPI

  const getKpiOption = (filters) => {
    if (filters.mode === "Custom") {
      return "Custom";
    }

    switch (filters.chip) {
      case "D":
        return "Past Day";
      case "W":
        return "Past Week";
      case "1M":
        return "Past Month";
      case "3M":
        return "Past 3 Months";
      case "YTD":
        return "YTD";
      case "1Y":
        return "Past Year";
      default:
        return "Past Month";
    }
  };

  useEffect(() => {
    const fetchKPIs = async () => {
      console.log(selectedDistrict, "selectedDistrict");
      const requestKey = getFilterKey(filters, districtId);

      if (kpiRequestKeyRef.current === requestKey) {
        return;
      }

      kpiRequestKeyRef.current = requestKey;

      try {
        setLoadingKpis(true);

        const option = getKpiOption(filters);

        if (option === "Custom" && (!filters.start || !filters.end)) {
          return;
        }

        const apiPayload = {
          option,
          interval: filters.interval || "Day",
          meter_ids: filters.meter || [],
          codes: filters.category || [],
          account_ids: filters.account || [],
        };

        if (option === "Custom") {
          apiPayload.start_date = filters.start;
          apiPayload.end_date = filters.end;
        }

        const data = await getWaterUsageKPI(apiPayload);
        setKpiData(data || {});
      } catch (error) {
        console.error("KPI API Error:", error.response?.data || error.message);
      } finally {
        setLoadingKpis(false);
      }
    };

    fetchKPIs();
  }, [
    districtId,
    filters.mode,
    filters.chip,
    filters.start,
    filters.end,
    filters.interval,
    filters.meter,
    filters.category,
    filters.account,
    selectedDistrict,
  ]);

useEffect(() => {
  const fetchRankings = async () => {
    if (!districtId) return;

    const requestKey = getFilterKey(filters, districtId);

    if (rankingRequestKeyRef.current === requestKey) {
      return;
    }

    rankingRequestKeyRef.current = requestKey;

    try {
      setLoadingRankings(true);

      const res = await getMetersByFlow(filters);
      const data = res?.data || res || [];

      setMeterRankings(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Ranked Meters API Error:", error);
      setMeterRankings([]);
    } finally {
      setLoadingRankings(false);
    }
  };

  fetchRankings();
}, [
  districtId,
  filters.mode,
  filters.chip,
  filters.start,
  filters.end,
  filters.interval,
  filters.account,
  filters.meter,
  filters.category,
]);

useEffect(() => {
  const fetchTrendData = async () => {
    if (!districtId) return;
    if (!filters.start || !filters.end) return;

    const requestKey = JSON.stringify({
        districtId,
      mode: filters.mode,
      chip: filters.chip,
      start: filters.start,
      end: filters.end,
      interval: filters.interval,
      account: filters.account || [],
      meter: filters.meter || [],
      category: filters.category || [],
      hourlyDay,
    });

    if (trendRequestKeyRef.current === requestKey) {
      return;
    }

    trendRequestKeyRef.current = requestKey;

    try {
      setLoadingCharts(true);

      const res = await getDailyHourlyTrend(filters);
      const apiData = res?.data;

      if (apiData) {
       const aggregate = (apiData.plots?.[0]?.data || [])
  .map((item) => {
    const timestamp = parseFlowTime(item.flow_time);

    return {
      x: timestamp,
      y: Number(item.flow || 0),
      label: item.flow_time,
    };
  })
  .filter((item) => item.x !== null);

        const dailyObj = apiData.daily_average_trends?.[0] || {};
        const dailyAvg = [
          { x: "Weekday", y: dailyObj.weekday_vs_weekend?.weekday || 0 },
          { x: "Weekend", y: dailyObj.weekday_vs_weekend?.weekend || 0 },
          ...(dailyObj.by_weekday || []).map((d) => ({
            x: d.weekday,
            y: d.average_daily_flow,
          })),
        ];

        const hourlyTrendRoot = apiData.hourly_average_trends?.[0] || {};
        let rawHourly = [];

        if (hourlyDay === "Weekdays") {
          rawHourly = hourlyTrendRoot.weekday_average || [];
        } else if (hourlyDay === "Weekends") {
          rawHourly = hourlyTrendRoot.weekend_average || [];
        } else {
          rawHourly = hourlyTrendRoot.by_weekday?.[hourlyDay] || [];
        }

        const hourlyAvg = rawHourly.map((h) => ({
          x: h.hour_12,
          y: h.average_flow,
        }));

        const weeklyRaw = apiData.weekly_trends?.[0]?.daily || [];
        const weeklyTrend = weeklyRaw.map((week) => {
          const flows = [0, 0, 0, 0, 0, 0, 0];

          const dayMap = {
            Monday: 0,
            Tuesday: 1,
            Wednesday: 2,
            Thursday: 3,
            Friday: 4,
            Saturday: 5,
            Sunday: 6,
          };

          week.days.forEach((day) => {
            const index = dayMap[day.weekday];
            if (index !== undefined) flows[index] = day.total_flow;
          });

          return { name: week.week_range, data: flows };
        });

        setChartData({
          aggregate,
          dailyAvg,
          hourlyAvg,
          weeklyTrend,
        });
      }
    } catch (error) {
      console.error("Trend API Error:", error);
    } finally {
      setLoadingCharts(false);
    }
  };

  fetchTrendData();
}, [
  districtId,
  filters.mode,
  filters.chip,
  filters.start,
  filters.end,
  filters.interval,
  filters.account,
  filters.meter,
  filters.category,
  hourlyDay,
]);

// ?breakdown by category and top accounts also depend on filters, so we can fetch together with trends or separately. Fetching separately for better loading states and faster UI response on filter change (trends can be slower to load)
useEffect(() => {
  const fetchUsageBreakdown = async () => {
    if (!districtId) return;

    const option = getKpiOption(filters);

    if (option === "Custom" && (!filters.start || !filters.end)) {
      setBreakdownData({
        breakdownTitle: "By Category",
        topFlowTitle: "Top Accounts — Total Flow In Range",
        categoryBreakdown: [],
        liveTopAccounts: [],
        totalFlowGallons: 0,
      });
      return;
    }

    const requestKey = getFilterKey(filters, districtId);

if (breakdownRequestKeyRef.current === requestKey) {
  return;
}

breakdownRequestKeyRef.current = requestKey;

    try {
      setLoadingBreakdown(true);
      setActiveCategory(null);

      const apiPayload = {
        option,
        interval: filters.interval || "Day",
        meter_ids: filters.meter || [],
        codes: filters.category || [],
        account_ids: filters.account || [],
      };

      if (option === "Custom") {
        apiPayload.start_date = filters.start;
        apiPayload.end_date = filters.end;
      }

      const res = await getWaterUsageBreakdown(apiPayload);

      const mappedBreakdown = (res?.breakdown?.items || []).map((item) => {
  const label =
    item.name ||
    item.category_name ||
    item.meter_name ||
    item.account_name ||
    "Unknown";

  return {
    name: label,
    value: Number(item.flowGallons || 0),
    sharePct: Number(item.sharePct || 0),

    // optional extra fields for tooltip / future use
    accountName: item.account_name || "",
    categoryName: item.category_name || "",
    meterName: item.meter_name || "",
  };
});

      const mappedTopFlowEntities = (res?.topFlowEntities?.items || []).map(
        (item) => ({
          name: item.name || "Unknown",
          value: Number(item.flowGallons || 0),
        })
      );

      setBreakdownData({
        breakdownTitle: res?.breakdown?.title || "By Category",
        topFlowTitle:
          res?.topFlowEntities?.title || "Top Accounts — Total Flow In Range",
        categoryBreakdown: mappedBreakdown,
        liveTopAccounts: mappedTopFlowEntities,
        totalFlowGallons: Number(res?.summary?.totalFlowGallons || 0),
      });
    } catch (error) {
      console.error(
        "Usage Breakdown API Error:",
        error.response?.data || error.message
      );

      setBreakdownData({
        breakdownTitle: "By Category",
        topFlowTitle: "Top Accounts — Total Flow In Range",
        categoryBreakdown: [],
        liveTopAccounts: [],
        totalFlowGallons: 0,
      });
    } finally {
      setLoadingBreakdown(false);
    }
  };

  fetchUsageBreakdown();
}, [
  districtId,
  filters.mode,
  filters.chip,
  filters.start,
  filters.end,
  filters.interval,
  filters.meter,
  filters.category,
  filters.account,
]);

  // =========================
  // RENDER
  // =========================

const handleMeterLinkClick = (event, row) => {
  event.stopPropagation();

  const meterId = row.meter || row.meter_id;

  if (!meterId) return;

  const category =
    row.code ||
    row.category ||
    row.code_name ||
    filters.category?.[0] ||
    "ALL";

  const selectedDate =
    filters.start ||
    new Date().toISOString().slice(0, 10);

  navigate(
    `/meter-leak-details?category=${encodeURIComponent(
      category,
    )}&meter_id=${encodeURIComponent(
      meterId,
    )}&time_range=Current&selected_time=${encodeURIComponent(selectedDate)}`,
    {
      state: {
        from: "water-usage",
        meter_id: meterId,
        account_name: row.account_name,
        category,
        flow: row.flow,
      },
    },
  );
};
  
  return (
    <div className="water-usage-page p-0">
      <h1
        className="text-4xl font-bold bg-clip-text text-transparent"
        style={{
          backgroundImage: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: "normal",
        }}
      >
        Water Usage
      </h1>

      <p className="mt-2" style={{ color: colors.textSecondary }}>
        District-wide consumption across meters, accounts, and categories
      </p>

      {/* <WaterUsageFilters
        accounts={accounts}
        meters={meters}
        categories={CATEGORIES}
        value={filters}
        onChange={setFilters}
        onDownload={() => {}}
      /> */}
  <WaterUsageFilters
  key={districtId}
  accounts={options.accounts}
  meters={options.meters}
  categories={options.categories}
  value={filters}
  onChange={setFilters}
  onOptionFilterChange={setOptionFilters}
  onDownload={() => {}}
/>
      {isFilteredView && (
        <div className="flex items-center gap-3 mt-4 text-[12px]">
          <span style={{ color: colors.textSecondary }}>
            ● Filtered view: {filteredText}
          </span>

          <button
            onClick={clearFilters}
            className="transition-all text-[12px]"
style={{ color: colors.primary }}
          >
            × Clear
          </button>
        </div>
      )}

      {/* <KPIStrip mode="district" data={activeKpis} /> */}
      {loadingKpis ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mt-4">
          {[1, 2, 3, 4, 5].map((item) => (
            <div
  key={item}
  className="rounded-xl p-4 min-h-[100px] flex items-center justify-center border"
  style={cardStyle}
>
              <Spin size="large" />
            </div>
          ))}
        </div>
      ) : (
        <KPIStrip mode={kpiData?.mode || "district"} data={kpiData || {}} />
      )}

      {/* Aggregate */}

      <SectionHeader
        title="District Aggregate Flow"
        badge="all meters · daily"
      />

      <div className="rounded-2xl p-5 mb-4 relative border min-h-[360px]"  style={cardStyle}>
  {/* INSIDE GRAPH CARD - TOP RIGHT */}
  <div className="absolute top-2 right-45 z-10">
    <ChartTypeToggle value={aggType} onChange={setAggType} />
  </div>

  {loadingCharts ? (
    <div className="h-[320px] flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : chartData.aggregate.length === 0 ? (
    <div className="h-[320px] flex items-center justify-center text-[#8ba1c7] text-sm font-semibold">
      No aggregate flow data available.
    </div>
  ) : (
<ReactApexChart
  key={`aggregate-${aggType}`}
  options={aggregateConfig}
  series={[
    {
      name: "Aggregate Flow",
      data: chartData.aggregate.map((p) => ({
        x: p.x,
        y: p.y,
      })),
    },
  ]}
  type={aggType}
  height={320}
/>
  )}
</div>

      {/* Daily / Hourly */}

      {/* <SectionHeader
        title="Daily / Hourly Average"
        badge="averages"
      >
        <ChartTypeToggle
          value={dhType}
          onChange={setDhType}
        />
      </SectionHeader> */}

     <div className="rounded-2xl p-5 border min-h-[500px]"  style={cardStyle}>
  <div className="flex items-center justify-between mb-5">
    {/* LEFT TABS */}
    <div
  className="flex items-center gap-2 rounded-lg p-1 border"
  style={innerCardStyle}
>
      <button
        onClick={() => setDhTab("daily")}
       className="px-4 py-2 rounded-md text-sm transition-all"
style={{
  backgroundColor: dhTab === "daily" ? colors.primary : "transparent",
  color:
    dhTab === "daily"
      ? colors.buttonText || "#ffffff"
      : colors.textSecondary,
}}
      >
        📅 Daily Average
      </button>

      <button
        onClick={() => setDhTab("hourly")}
        className="px-4 py-2 rounded-md text-sm transition-all"
style={{
  backgroundColor: dhTab === "hourly" ? colors.primary : "transparent",
  color:
     dhTab === "hourly"
      ? colors.buttonText || "#ffffff"
      : colors.textSecondary,
}}
       
      >
        ⏱ Hourly Average
      </button>
    </div>

    {/* RIGHT TOGGLE */}
    {dhTab === "daily" ? (
      <ChartTypeToggle value={dailyType} onChange={setDailyType} />
    ) : (
      <ChartTypeToggle value={hourlyType} onChange={setHourlyType} />
    )}
  </div>

  {loadingCharts ? (
    <div className="h-[420px] flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : dhTab === "daily" ? (
    chartData.dailyAvg.length === 0 ? (
      <div className="h-[420px] flex items-center justify-center text-[#8ba1c7] text-sm font-semibold">
        No daily average data available.
      </div>
    ) : (
      <ReactApexChart
        options={{
          ...dailyConfig,
          xaxis: {
            categories: chartData.dailyAvg.map((p) => p.x),
          },
        }}
        series={[
          {
            name: "Daily Avg",
            data: chartData.dailyAvg.map((p) => p.y),
          },
        ]}
        type={dailyType}
        height={420}
      />
    )
  ) : (
    <div className="grid grid-cols-12 gap-6">
      {/* LEFT FILTER PANEL */}
      <div className="col-span-12 lg:col-span-2">
        <div
  className="rounded-xl p-4 min-h-[420px] border"
  style={innerCardStyle}
>
          <div className="space-y-4">
            {[
              "Weekdays",
              "Weekends",
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ].map((day) => (
              <label
                key={day}
                className="flex items-center gap-3 text-sm cursor-pointer"
style={{ color: colors.text }}
              >
                <input
                  type="radio"
                  name="hourlyDay"
                  checked={hourlyDay === day}
                  onChange={() => setHourlyDay(day)}
                  className="accent-cyan-500"
                />

                <span>{day}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT CHART */}
      <div className="col-span-12 lg:col-span-10">
        {chartData.hourlyAvg.length === 0 ? (
          <div className="h-[420px] flex items-center justify-center text-[#8ba1c7] text-sm font-semibold">
            No hourly average data available.
          </div>
        ) : (
          <ReactApexChart
            options={{
              ...hourlyConfig,
              xaxis: {
                categories: chartData.hourlyAvg.map((p) => p.x),
              },
            }}
            series={[
              {
                name: "Hourly Avg",
                data: chartData.hourlyAvg.map((p) => p.y),
              },
            ]}
            type={hourlyType}
            height={420}
          />
        )}
      </div>
    </div>
  )}
</div>

      {/* Breakdown */}

    {/* <SectionHeader title="Breakdown" badge="by category & account" /> */}
    <SectionHeader title="Breakdown" />

<div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-stretch">
  {/* LEFT DONUT CARD */}
  <div
  className="rounded-xl p-5 h-[520px] border"
  style={cardStyle}
>
    <div className="text-sm mb-2" style={mutedTextStyle}>
      {breakdownTitle || "By Category"}
    </div>

    {loadingBreakdown ? (
      <div className="h-[320px] flex items-center justify-center">
        <Spin size="large" />
      </div>
    ) : categoryBreakdown.length === 0 ? (
      <div className="h-[320px] flex items-center justify-center text-sm font-semibold"
style={mutedTextStyle}>
        No breakdown data available.
      </div>
    ) : (
     <ReactApexChart
  options={{
    ...categoryConfig,
    labels: categoryBreakdown.map((c) => c.name),
  }}
  series={categoryBreakdown.map((c) => c.value)}
  type="donut"
  height={320}
/>
    )}
  </div>

  {/* RIGHT TOP ACCOUNTS CARD */}
<div
  className="rounded-xl p-5 h-[420px] border"
  style={cardStyle}
>
  <div className="flex items-start justify-between mb-3">
    <div
      className="text-sm"
      style={{ color: colors.textSecondary }}
    >
      {topFlowTitle || "Top Accounts — Total Flow In Range"}
    </div>

    <ChartTypeToggle value={acctType} onChange={setAcctType} />
  </div>

  {loadingBreakdown ? (
    <div className="h-[290px] flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : liveTopAccounts.length === 0 ? (
    <div
      className="h-[290px] flex items-center justify-center text-sm font-semibold"
      style={{ color: colors.textSecondary }}
    >
      No top flow data available.
    </div>
  ) : (
    <ReactApexChart
      options={accountConfig}
      series={[
        {
          name: "Total Flow",
          data: liveTopAccounts.map((a) => Number(a.value || 0)),
        },
      ]}
      type={acctType}
      height={290}
    />
  )}
</div>
</div>
      {/* Weekly */}

      <SectionHeader
        title="Weekly Trend"
        badge="Mon → Sun, one line per ISO week"
      />

     <div className="rounded-md p-5 min-h-[430px] border"  style={{
    backgroundColor: colors.cardBg,
    borderColor: colors.border,
  }}>
  <p className="text-sm mb-4" style={mutedTextStyle}>
    Day-of-week pattern across the selected range. Click a week in the
    legend to isolate it.
  </p>

  {loadingCharts ? (
    <div className="h-[360px] flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : chartData.weeklyTrend.length === 0 ? (
    <div className="h-[360px] flex items-center justify-center text-[#8ba1c7] text-sm font-semibold">
      No weekly trend data available.
    </div>
  ) : (
    <WeeklyTrendChart weeks={chartData.weeklyTrend} height={360} />
  )}
</div>

      {/* Table */}

      <SectionHeader title="Meters by Flow" badge="ranked" />

      <div className="rounded-md p-4 overflow-auto mb-4 border min-h-[360px]"  style={cardStyle}>
  <p className="text-sm mb-4" style={mutedTextStyle}>
    Click any column header to sort. Click a meter or account to filter.
  </p>

  {loadingRankings ? (
    <div className="h-[300px] flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : paginatedMeters.length === 0 ? (
    <div className="h-[300px] flex items-center justify-center text-[#8ba1c7] text-sm font-semibold">
      No meter flow data available.
    </div>
  ) : (
    <>
      <table className="w-full border-collapse text-sm">
        <thead>
         <tr
  className="border-b"
  style={{
    borderColor: colors.border,
    backgroundColor: colors.rowAlt2 || colors.background,
  }}
>
            <th
              className="text-left py-4 px-6 font-semibold text-sm"
              style={{ color: colors.textSecondary }}
            >
              #
            </th>

            <th
              onClick={() => onSortClick("meter")}
              className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              <span className="flex items-center gap-2 select-none">
                Meter
                <SortIcon columnKey="meter" />
              </span>
            </th>

            <th
              onClick={() => onSortClick("code_name")}
              className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              <span className="flex items-center gap-2 select-none">
                Category
                <SortIcon columnKey="code_name" />
              </span>
            </th>

            <th
              onClick={() => onSortClick("account_name")}
              className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              <span className="flex items-center gap-2 select-none">
                Account
                <SortIcon columnKey="account_name" />
              </span>
            </th>

            <th
              onClick={() => onSortClick("last_comm_time")}
              className="text-left py-4 px-6 font-semibold text-sm cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              <span className="flex items-center gap-2 select-none">
                Last Comm
                <SortIcon columnKey="last_comm_time" />
              </span>
            </th>

            <th
              onClick={() => onSortClick("flow")}
              className="text-right py-4 px-6 font-semibold text-sm cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              <span className="flex items-center justify-end gap-2 select-none">
                Flow (gal)
                <SortIcon columnKey="flow" />
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          {paginatedMeters.map((m, i) => (
            <tr
              key={`${m.meter || m.meter_id}-${i}`}
              className="border-b transition-colors"
              style={{
                borderColor: colors.border,
                backgroundColor: colors.cardBg,
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = colors.hoverBg)
              }
            onMouseLeave={(e) =>
  (e.currentTarget.style.backgroundColor = colors.cardBg)
}
            >
              <td className="py-4 px-6 text-sm" style={{ color: colors.text }}>
                {meterStartIndex + i + 1}
              </td>

              <td className="py-4 px-6 text-sm">
  <button
    type="button"
    onClick={(event) => handleMeterLinkClick(event, m)}
    className="font-bold underline decoration-1 underline-offset-4 cursor-pointer"
    style={{
      color: colors.primary,
      background: "transparent",
      border: "none",
      padding: 0,
    }}
  >
    {m.meter || m.meter_id}
  </button>
</td>

              <td className="py-4 px-6 text-sm" style={{ color: colors.text }}>
                {m.code_name || "-"}
              </td>

              <td
                className="py-4 px-6 text-sm cursor-pointer"
                style={{ color: colors.primary }}
              >
                {m.account_name || "-"}
              </td>

              <td className="py-4 px-6 text-sm" style={{ color: colors.text }}>
                {m.last_comm_time || "-"}
              </td>

              <td
                className="py-4 px-6 text-sm text-right font-semibold"
                style={{ color: colors.primary }}
              >
                {Number(m.flow || 0).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

     {meterTotalPages > 0 && (
  <div
    className="flex items-center justify-between p-4 border-t flex-wrap gap-4"
    style={{
      borderColor: colors.border,
      backgroundColor: colors.cardBg,
    }}
  >
    <div className="text-xs" style={mutedTextStyle}>
      Showing {meterStartIndex + 1} to{" "}
      {Math.min(meterStartIndex + meterPageSize, sortedMeters.length)} of{" "}
      {sortedMeters.length} records
    </div>

    <div className="flex items-center gap-6 flex-wrap">
      <div className="flex items-center gap-2">
        {/* PREVIOUS */}
        <button
          disabled={meterPage === 1}
          onClick={() => setMeterPage((p) => Math.max(p - 1, 1))}
          className="p-1.5 rounded-md border transition-all"
          style={{
            borderColor: meterPage === 1 ? colors.border : colors.primary,
            color: meterPage === 1 ? colors.textSecondary : colors.primary,
            backgroundColor: colors.background,
            opacity: meterPage === 1 ? 0.45 : 1,
            cursor: meterPage === 1 ? "not-allowed" : "pointer",
          }}
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-2 px-2">
          <span className="text-sm" style={mutedTextStyle}>
            Page
          </span>

          <select
            value={meterPage}
            onChange={(e) => setMeterPage(Number(e.target.value))}
            className="text-sm rounded-md px-2 py-1 outline-none border cursor-pointer"
            style={{
              backgroundColor: colors.background,
              borderColor: colors.border,
              color: colors.text,
            }}
          >
            {Array.from({ length: meterTotalPages }, (_, i) => i + 1).map(
              (p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              )
            )}
          </select>

          <span className="text-sm" style={mutedTextStyle}>
            of {meterTotalPages}
          </span>
        </div>

        {/* NEXT */}
        <button
          disabled={meterPage === meterTotalPages}
          onClick={() =>
            setMeterPage((p) => Math.min(p + 1, meterTotalPages))
          }
          className="p-1.5 rounded-md border transition-all"
          style={{
            borderColor:
              meterPage === meterTotalPages ? colors.border : colors.primary,
            color:
              meterPage === meterTotalPages
                ? colors.textSecondary
                : colors.primary,
            backgroundColor: colors.background,
            opacity: meterPage === meterTotalPages ? 0.45 : 1,
            cursor:
              meterPage === meterTotalPages ? "not-allowed" : "pointer",
          }}
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      <div className="flex items-center gap-2 text-sm" style={mutedTextStyle}>
        <span>Rows:</span>

        <select
          value={meterPageSize}
          onChange={(e) => {
            setMeterPageSize(Number(e.target.value));
            setMeterPage(1);
          }}
          className="rounded px-2 py-1 text-sm border outline-none cursor-pointer"
          style={{
            backgroundColor: colors.background,
            borderColor: colors.border,
            color: colors.text,
          }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>
    </div>
  </div>
)}
    </>
  )}
</div>
    </div>
  );
};

// =========================
// HELPERS
// =========================

function SectionHeader({ title, badge, children }) {
  const { colors } = useTheme();

  return (
    <div className="flex items-center justify-between mb-3 mt-8">
      <div className="flex items-center gap-3">
        <h2
          className="text-[16px] font-semibold"
          style={{ color: colors.text }}
        >
          {title}
        </h2>

        {badge && (
          <span
            className="px-3 py-1 rounded-full text-[11px] border"
            style={{
              backgroundColor: `${colors.primary}15`,
              color: colors.primary,
              borderColor: `${colors.primary}40`,
            }}
          >
            {badge}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <button
          className="text-[14px] transition-all"
          style={{ color: colors.textSecondary }}
        >
          ↓ Download
        </button>

        {children}
      </div>
    </div>
  );
}
function ChartTypeToggle({ value, onChange }) {
  const { colors } = useTheme();

  return (
    <div
      className="flex items-center rounded-lg overflow-hidden h-[34px] border"
      style={{
        backgroundColor: colors.background,
        borderColor: colors.border,
      }}
    >
      <button
        onClick={() => onChange("bar")}
        className="px-4 h-full text-sm font-medium transition-all"
        style={{
          backgroundColor: value === "bar" ? colors.primary : "transparent",
          color:
            value === "bar"
              ? colors.buttonText || "#ffffff"
              : colors.textSecondary,
        }}
      >
        ▮▮
      </button>

      <button
        onClick={() => onChange("line")}
        className="px-4 h-full text-sm font-medium transition-all"
        style={{
          backgroundColor: value === "line" ? colors.primary : "transparent",
          color:
            value === "line"
              ? colors.buttonText || "#ffffff"
              : colors.textSecondary,
        }}
      >
        ∿
      </button>
    </div>
  );
}
export default WaterCombined;
